<template>
	<div class="detrusion">
		<div class="title">指派给</div>
		<div class="detrusion-main">
			<div class="dtree-select">
				<!-- <a-tree-select
				  style="width: 100%"
				  :value="value"
				  :dropdownStyle="{ maxHeight: '300px', overflow: 'auto' }"
				  placeholder="请选择报告机构"
				  allowClear
				  autoExpandParent
				  @change="onChange"
				  :treeData="treeData"
				>
				</a-tree-select>-->
				<a-tree-select
						:getPopupContainer="triggerNode => triggerNode.parentNode"
						style="width: 100%"
						:value="value"
						:dropdownStyle="{ maxHeight: '300px', overflow: 'auto' }"
						placeholder="请选择报告机构"
						showSearch
						allowClear
						treeDefaultExpandAll
						@change="onChange"
				>
					<a-tree-select-node
							v-for="(item) in treeData"
							:selectable="false"
							:value="item.deptName"
							:title="item.deptName"
							:key="item.deptId"
					>
						<a-tree-select-node
								v-for="(cItem) in item.children"
								:value="cItem.deptName"
								:title="cItem.deptName"
								:key="cItem.deptId"
						/>
					</a-tree-select-node>
				</a-tree-select>
			</div>
			<a-button type="primary" class="confirm-primary" @click="appointJobs()">确定</a-button>
		</div>
	</div>
</template>

<script>
  export default {
    data() {
      return {
        treeExpandedKeys: [],
        value: undefined,
        valueId: undefined,
        total: "",
        treeData: [],
        userId: "",
        ids: [],
        timeOut: null
      };
    },
    props: ["selectedData"],
    methods: {
      onChange(value, label, extra) {
        this.value = value;
        this.valueId = value ? extra.triggerNode.eventKey : '';
        // var tag = value.toString().substring(7);
        // this.userId = tag;
      },
      onSelect(data) {
      },
      //指派的效果
      appointJobs() {
        let _this = this;
        // if (this.value) {
        this.ids = [];
        this.selectedData.map(item => {
          this.ids.push(item.id);
        });

        this.$post(
          "report/report/assignReport",
          {
            ids: this.ids.join(","),
            deptId: this.valueId || ''
          }
        ).then(res => {
          if (res.data.code == 1) {
            this.$message.success("操作成功");
            this.$emit('close');
            this.$emit('update');
          } else {
            this.$message.error(res.data.message);
          }
        });
        // } else {
        //   this.$message.error("请选择报告机构");
        // }
      },
      // 指派给某个人
      onLoadData(treeNode) {
        let _this = this;
        return new Promise(resolve => {
          if (treeNode.dataRef.children.length > 0) {
            resolve();
            return;
          }
          // if (!treeNode.dataRef.children) {
          setTimeout(() => {
            _this
              .$get("/user", {
                deptId: treeNode.dataRef.deptId
              })
              .then(res => {
                let newData = res.data.rows;
                // newData.map((item, index) => {
                //   item.title = item.nickName;
                //   // item.selectable = true;
                //   item.key = _this.total + index + 2;
                //   item.value = "userId_" + item.userId;
                //   // item.isLeaf = true;
                //   return item;
                // });
                // treeNode.dataRef.children = newData;
                // _this.treeData = [..._this.treeData];
                _this.treeData = newData;
                resolve();
              });
          }, 1000);
          // }
        });
      },
      // 查找组织机构
      // GET /api/dept/findDeptList
      findDeptList() {
        this.$get("dept/findDeptTreeList", {
          pageSize: 999999,
          pageNum: 1
        }).then(res => {
          this.treeData = res.data.data;
        });
      }
    },
    created() {
      this.findDeptList();
    }
  };
</script>

<style lang="scss" scoped>
	.detrusion {
		.title {
			padding: 82px 0 56px 0;
			font-size: 26px;
			font-family: PingFang SC;
			font-weight: 400;
			color: rgba(51, 51, 51, 1);
		}
		.detrusion-main {
			width: 510px;
			margin: 0 auto;
		}

		.dtree-select {
			height: 350px;
		}
	}
</style>